{
  "longPressMessage": "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
}
